export default __webpack_public_path__ + "static/media/logo.c1213227.png";